import React from 'react'
import style from './badge.module.scss'

const Badge = ({ children, icon, className }) => (
  <div className={`${style.badge} ${className}`}>{children}</div>
)

export default Badge
